import styled from "styled-components";
import PopUpImg from "../img/wallpaper_60_1024.png"


function VipRequestSuccess(props){

    return(
        <MasterContainer>
        <VipRequestMaster>

            <TitleMaster>
                <h1>Vip Solicitado com Sucesso!</h1>
                <span>Obrigado por <b>Doar e apoiar nosso projeto ♥</b> <br/><br/>

                Seu acesso Vip será liberado <b>automaticamente</b>, assim que a Doação for <b>confirmada pela provedora</b>.<br/><br/>

                Esperamos que você aproveite e tenha uma aventura incrível aqui no nosso servidor!<br/><br/>


                Abaixo você confere o código da sua Doação e solicitação de acesso VIP.<br/>
                </span>
            </TitleMaster>

            
            <ResumeMaster>
                <Legend>Código de Solicitação</Legend>
                <RequestCode> <h1>{props.code}</h1> </RequestCode>
            </ResumeMaster>

            <Clause> <span>Uma aba para o site da provedora de pagamento foi aberto no seu navegador.</span> </Clause>

            <Clause> <span>Link para o pagamento: <a target='_blank' href={props.paymentLink}>Mercado Pago</a> </span> </Clause>

        </VipRequestMaster>

        <BgPopUp bgp={PopUpImg}/>
        </MasterContainer>
    )
}

export default VipRequestSuccess;

const VipRequestMaster = styled.div`
    background-color: white;
    display: flex;
    flex-direction: column;
    align-items: center;
    border-radius: 10px;
    width: 700px;
    //border: solid 1px black;
    //box-shadow: 10px 10px 10px 0px black;
`

const TitleMaster = styled.div`
    width: 550px;
    //border: solid;
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: justify;
    margin-bottom: 30px;

`

const ResumeMaster = styled.fieldset`
    width: 510px;
    border-top: solid 1px black;
    //border: none;
    padding: 20px;
    overflow: auto;
    margin-top: 0px;
    margin-bottom: 30px;

`

const Legend = styled.legend`
    font-size: 24pt;
    font-weight: bold;
    text-align: center;

`

const Clause = styled.div`
    text-align: center;
    margin-bottom: 30px;
    width: 100%;
    //border: solid;
    font-size: 14pt;
`

const RequestCode = styled.div`
    text-align: center;
    width: 100%;
    //border: solid;
    font-size: 18pt;
`

const BgPopUp = styled.div`
    background-image: url(${props => props.bgp});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 525px;
    height: 730px;
    //border: solid;

    @media(max-width: 1000px) {
      background-image: url('');
      width: 0px;
    }
`

const MasterContainer = styled.div`
    display: flex;
    border: solid 1px;
    align-items: center;
    background-color: white;
    border-radius: 10px;
    box-shadow: 10px 10px 10px 0 black;
    height: 100%;
`
